import { useState } from 'react';
import { Operator } from '../../../types/sharedTypeImpl.ts';
import { trpc, trpcClient } from '../../../utils/trpc/trpc.ts';
import { OperatorDialog } from './operatorDialog.tsx';
import { OperatorsTable } from './operatorsTable.tsx';

interface DialogState {
    isOpen: boolean,
    operator?: Operator,
}


export function Operators() {
    const [dialogState, setDialogState] = useState<DialogState | null>(null);
    const [displayInactive, setDisplayInactive] = useState(false);

    const operatorsQuery = trpc.operators.getAll.useQuery(undefined, {
        select: (operators) =>
            [...operators].sort((a, b) => (a.shiftTeam ?? '').localeCompare(b.shiftTeam ?? '') || a.initials.localeCompare(b.initials)),
    });
    const operators = operatorsQuery.data;
    const visibleOperators = displayInactive ? operators : operators?.filter((operator) => operator.isActive);

    const handleAddOperatorClick = () => {
        setDialogState({ isOpen: true });
    };

    const handleOperatorIsActiveChange = async (operator: Operator, isActive: boolean) => {
        await trpcClient.operators.set.mutate({ ...operator, isActive });
        operatorsQuery.refetch();
    };

    return (
        <>
            <div>
                <h2>Operators</h2>
                <button onClick={handleAddOperatorClick}>Add operator</button>
                <div style={{ margin: '12px 0' }}>
                    <label style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                        <input type='checkbox' checked={displayInactive} onChange={(event) => setDisplayInactive(event.target.checked)} />
                        Display inactive
                    </label>
                </div>
                {operatorsQuery.isLoading && <div>Loading...</div>}
                {operatorsQuery.error && <div>Error retrieving data</div>}
                {operators && (
                    <OperatorsTable
                        style={{ width: '600px' }}
                        operators={visibleOperators ?? []}
                        onIsActiveChange={handleOperatorIsActiveChange}
                        onEditClick={(operator) => setDialogState({ isOpen: true, operator })}
                    />
                )}
            </div>

            {dialogState?.isOpen && operators && (
                <OperatorDialog
                    operator={dialogState.operator}
                    operators={operators}
                    onOperatorAdded={() => operatorsQuery.refetch()}
                    onClose={() => {
                        setDialogState(null);
                    }}
                />
            )}
        </>
    );
}
